import { z } from 'zod';
export const Perspective = z.string();
export const CartItemType = z.union([z.literal('similar'), z.literal('existing')]);
